export default __webpack_public_path__ + "static/10-code-combat-0bb36d26c06b7c2a03ccbd58f19d3869.png";